import React from 'react'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/styles'
import PermContactCalendarOutlinedIcon from 'components/material-symbol/icons/PermContactCalendar'
import SectionEmptyState from 'components/section-empty-state'

const useStyles = makeStyles(theme => ({
  listEmptyStateContent: {
    padding: theme.spacing(4, 2),
  },
}))

const EmptyListView = ({
  title = 'Students',
  caption = 'Your Students will appear here.',
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.listEmptyStateContent}>
      <SectionEmptyState
        Icon={PermContactCalendarOutlinedIcon}
        title={title}
        caption={caption}
        bordered={false}
      />
    </Box>
  )
}

export default EmptyListView
